const alarm = {
  email: '邮件',
  sms: '短信',
  webPage: '页面推送',
  alarmThreshold: '告警阀值',
  repeatable: '可重复',
  alarmNotice: '告警通知',
  alarmConfig: '告警设置',
  halfDay: '半天',
  aDay: '一天',
  twoDays: '两天',
  threeDays: '三天',
  descriptionRule: '请输入告警描述',
  thresholdRule: '请输入告警阀值',
  fenceAlarm: '围栏告警',
  integratorTip: '集成商只能查看自己的告警列表!',
  selectedNum: '已选择{num}项',
  search: '搜索',
  packUp: '收起',
  moreSearchType: '更多查询方式',
  autoRecovery: '自动处理',
  ringType: '响铃类型',
  ringOnce: '响一声',
  ringAlways: '一直响',
  ringNone: '不响',
  alarmSecondThreshold: '告警阀值上限',
  // 告警类型国际化
  围栏告警: '围栏告警',
  表带损坏告警: '表带损坏告警',
  异常开锁告警: '异常开锁告警',
  SOS告警: 'SOS告警',
  失联告警: '失联告警',
  设备低电告警: '设备低电告警',
  跌倒告警: '跌倒告警',
  心率异常告警: '心率异常告警',
  滞留告警: '滞留告警',
  隔离人员外出告警: '隔离人员外出告警',
  heartRateThresholdMin:'输入值需在1-100之间的整数！',
  heartRateThresholdMax:'输入值需在100-200之间的整数！',
  lessThan:"小于",
  greaterThan:"大于",
  optName:'经手人员',
  confirmTime:'处理时间',
  annotation:'处理意见',
  手环佩戴:'手环佩戴',
  手环摘除:'手环摘除',
  心率异常:'心率异常',
  人员已删除:'人员已删除',
  体温异常告警:'体温异常告警',
  上班打卡:'上班打卡',
  下班打卡:'下班打卡',
  超员告警:'超员告警',
  SOS取消:'SOS取消',
}
export default alarm